import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from '../../../services/authservices.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  loading = false
  eventArr = []
  totalitems
  objArr = []
  pageSize
  totalItems
  pageNo
  arr = [1, 2, 3, 4]
  faqarr = []
  constructor(private authService: AuthservicesService, private router: Router) {

    this.pageSize = environment.pageSize
  }
  ngOnInit(): void {
    this.getFaq(1);
  }


  getFaq(event) {
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.authService.getfaq(skip, this.pageSize).subscribe((res: any) => {
      this.loading = true
      this.faqarr = res.items
      this.totalitems = res.total
    },

      error => {
        this.loading = true
        this.authService.successMessage(error.error.message, 'error')
      })
  }
}
